import { useEffect, useState } from "react";

const ScrollComponent = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const option = {
    threshold: [0, 0.2, 0.5, 0.7, 1],
  };
  useEffect(() => {
    const callback = (entries, observe) => {
      entries.forEach((entry) => {
        const ratio = entries[0].intersectionRatio;
        if (document.querySelector("#tip")) {
          document.querySelector("#tip").textContent = `Threshold = ${ratio}, index: ${currentIndex}`;
          if (entry.isIntersecting) {
            const observedIndex = parseInt(entry.target.dataset.index, 10);
            // 仅当当前图片索引更接近顶部时才更新 currentIndex
            if (observedIndex !== currentIndex) {
              console.log(`${currentIndex} 已进入`);
              setCurrentIndex(observedIndex);
            }
          }
        }
      });
    };
    const observer = new IntersectionObserver(callback, option);
    observer.observe(document.querySelector("#b1"));
    observer.observe(document.querySelector("#b2"));
    observer.observe(document.querySelector("#b3"));
    observer.observe(document.querySelector("#b4"));
    observer.observe(document.querySelector("#b5"));
  }, []);
  return (
    <>
      <div className=" fixed top-0 left-0 m-2 p-2 rounded-md shadow-md" id="tip"></div>
      <div className=" m-2 p-2 rounded-md shadow-md mt-96 w-96 h-96 bg-red-400" id="b1">
        box1
      </div>
      <div className=" m-2 p-2 rounded-md shadow-md mt-96 w-96 h-96 bg-red-400" id="b2">
        box2
      </div>
      <div className=" m-2 p-2 rounded-md shadow-md mt-96 w-96 h-96 bg-red-400" id="b3">
        box3
      </div>
      <div className=" m-2 p-2 rounded-md shadow-md mt-96 w-96 h-96 bg-red-400" id="b4">
        box4
      </div>
      <div className=" m-2 p-2 rounded-md shadow-md mt-96 w-96 h-96 bg-red-400" id="b5">
        box5
      </div>
    </>
  );
};

export default ScrollComponent;
